export default {"src":"/login-app/[GIT_HASH]/_next/static/media/create_view.22b1e087.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};